var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import classNames from 'classnames';
import Signals from '../../../../signals/Signals';
/**
 *
 */
var Overlay = /** @class */ (function (_super) {
    __extends(Overlay, _super);
    /**
     *
     * @param props
     */
    function Overlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showOverlay: false,
            content: null
        };
        _this.show = _this.show.bind(_this);
        _this.hide = _this.hide.bind(_this);
        _this.onBackgroundClick = _this.onBackgroundClick.bind(_this);
        Signals.ShowOverlay.add(_this.show);
        Signals.HideOverlay.add(_this.hide);
        return _this;
    }
    /**
     *
     */
    Overlay.prototype.componentWillUnmount = function () {
        Signals.ShowOverlay.remove(this.show);
        Signals.HideOverlay.remove(this.hide);
    };
    /**
     *
     * @return {*}
     */
    Overlay.prototype.render = function () {
        var _this = this;
        var classes = classNames({
            'overlay py-4 px-2': true,
            'overlay--show': this.state.showOverlay,
            'overlay--hide': !this.state.showOverlay
        });
        return (React.createElement("div", { ref: function (ref) { return _this.el = ref; }, className: classes },
            React.createElement("div", { ref: function (ref) {
                    _this.backgroundElement = ref;
                }, className: "overlay__background", onClick: this.onBackgroundClick }),
            React.createElement("div", { className: "overlay__scroll-panel" },
                React.createElement("div", { ref: function (ref) {
                        _this.contentWrapperElement = ref;
                    }, className: "overlay__content-wrapper", onMouseDown: this.onBackgroundClick }, this.state.content))));
    };
    /**
     *
     * @param e
     */
    Overlay.prototype.onBackgroundClick = function (e) {
        if (e.target === this.contentWrapperElement || e.target === this.backgroundElement) {
            Signals.OverlayBackgroundClick.dispatch();
            this.hide();
        }
    };
    /**
     *
     * @param content
     */
    Overlay.prototype.show = function (content) {
        //if (!this.state.showOverlay) {
        clearTimeout(this.hideTimeout);
        this.setState({ content: content, showOverlay: true });
        this.lockPage();
        //}
    };
    /**
     *
     */
    Overlay.prototype.hide = function () {
        var _this = this;
        if (this.state.showOverlay) {
            clearTimeout(this.hideTimeout);
            this.setState({ showOverlay: false });
            this.hideTimeout = setTimeout(function () {
                _this.unlockPage();
                _this.setState({ content: null });
            }, 300);
        }
    };
    /**
     *
     */
    Overlay.prototype.lockPage = function () {
        this.lockTarget = document.querySelector('.page');
        if (this.lockTarget && this.el) {
            this.el.style.display = 'block';
            this.lockTargetBoundingClientRect = this.lockTarget.getBoundingClientRect();
            this.lockTarget.classList.add('page--locked');
            this.lockTarget.style.top = this.lockTargetBoundingClientRect.y + 'px';
            window.scrollTo(0, 0);
        }
    };
    /**
     *
     */
    Overlay.prototype.unlockPage = function () {
        if (this.lockTarget && this.el) {
            this.lockTarget.style.top = 'inherit';
            this.lockTarget.classList.remove('page--locked');
            this.lockTarget.scrollTop = this.lockTargetBoundingClientRect.y;
            this.el.style.display = 'none';
            window.scrollTo(0, -this.lockTargetBoundingClientRect.y);
        }
        this.lockTargetBoundingClientRect = null;
        this.lockTarget = null;
    };
    return Overlay;
}(React.Component));
export default Overlay;
